import { Link } from "react-router-dom";
import { CONTACT_EMAIL, SCHOLAR_URL } from "../lib/constants";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-charcoal text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-5">
              <span className="w-2.5 h-2.5 bg-acid rounded-full" />
              <span className="font-mono-sci text-sm tracking-tight">SYSTEMS BEYOND</span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed max-w-sm">
              An independent complex-systems research lab and consultancy. We use mathematical
              modeling, computational simulation and systems thinking to make complex problems
              understandable.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-white/40 mb-4">Explore</p>
            <ul className="space-y-2.5 text-sm text-white/70">
              <li><Link to="/independent-research" className="hover:text-acid transition-colors">Independent Research</Link></li>
              <li><Link to="/for-research-teams" className="hover:text-acid transition-colors">For Research Teams</Link></li>
              <li><Link to="/for-smes" className="hover:text-acid transition-colors">For SMEs</Link></li>
              <li><Link to="/articles" className="hover:text-acid transition-colors">Articles</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline text-white/40 mb-4">Contact</p>
            <ul className="space-y-2.5 text-sm text-white/70">
              <li><a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-acid transition-colors" data-testid="footer-email">{CONTACT_EMAIL}</a></li>
              <li><a href={SCHOLAR_URL} target="_blank" rel="noopener noreferrer" className="hover:text-acid transition-colors">Google Scholar</a></li>
              <li><Link to="/contact" className="hover:text-acid transition-colors">Book a Consultation</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3">
          <p className="font-mono-sci text-xs text-white/40">© {new Date().getFullYear()} SYSTEMS BEYOND — INDEPENDENT RESEARCH & CONSULTING</p>
          <p className="font-mono-sci text-xs text-white/40">FOUNDED BY DAVID MARTINEZ, PhD</p>
        </div>
      </div>
    </footer>
  );
};
